export const LOCALES = ['en', 'tr', 'de'] as const;

export type Locale = (typeof LOCALES)[number];

export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE';
export const DEFAULT_LOCALE: Locale = 'en';

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'en' || value === 'tr' || value === 'de';
}

export function getLocaleFromAcceptLanguage(headerValue: string | null): Locale {
  if (!headerValue) return DEFAULT_LOCALE;

  const languages = headerValue
    .split(',')
    .map((part) => part.split(';')[0]?.trim().toLowerCase())
    .filter(Boolean);

  for (const language of languages) {
    if (language === 'tr' || language.startsWith('tr-')) return 'tr';
    if (language === 'de' || language.startsWith('de-')) return 'de';
    if (language === 'en' || language.startsWith('en-')) return 'en';
  }

  return DEFAULT_LOCALE;
}
